export class ScheduleEntryModel {
    startHour: string;
    endHour: string;

    constructor(startHour: string = '00:00', endHour: string = '00:00') {
        this.startHour = startHour;
        this.endHour = endHour;
    }
}